import axios from "axios";

const state = {
    solicitudesRechazadas: null,
    solicitudRechazadaSeleccionada: null,
    totalPaginas: null,
};

const getters = {
    solicitudesRechazadas: (state) => state.solicitudesRechazadas,
    solicitudRechazadaSeleccionada: (state) => state.solicitudRechazadaSeleccionada,
    totalPaginas: (state) => state.totalPaginas,
};

const mutations = {
    setSolicitudesRechazadas: (state, solicitudesRechazadas) => {
        state.solicitudesRechazadas = solicitudesRechazadas;
    },
    setSolicitudRechazadaSeleccionada: (state, solicitudRechazadaSeleccionada) => {
        state.solicitudRechazadaSeleccionada = solicitudRechazadaSeleccionada;
    },

    setTotalPaginas: (state, data) => {
        state.totalPaginas = data;
    },
};

const actions = {

    async consultarSolicitudesXPagina({commit}, data) {
        try {
            let res = await axios.get(`/v1/solicitudes-rechazadas/${data.pagina}/pagina`);
            commit("setSolicitudesRechazadas", res?.data?.result);
        } catch (error) {
            return error;
        }
    },
    async consultarTotalPaginas({commit}) {
        try {
            const resp = await axios.get(`/v1/solicitudes-rechazadas/total`);
            commit("setTotalPaginas", resp?.data?.totalPaginas);
            return resp?.data?.totalPaginas || 0;
        } catch (error) {
            return error;
        }
    },
    async agregarExcepcion({ commit }, data) {
      try {
        await axios.post(`/v1/solicitudes-rechazadas/excepcion`, data);
        let res = await axios.get(`/v1/solicitudes-rechazadas/1/pagina`);
            commit("setSolicitudesRechazadas", res?.data?.result);
      } catch (error) {
        return error;
      }
    },
    async agregarExcepciones({ commit }, data) {
      try {
        await axios.post(`/v2/solicitudes-rechazadas/excepcion`, data);
        let res = await axios.get(`/v1/solicitudes-rechazadas/1/pagina`);
            commit("setSolicitudesRechazadas", res?.data?.result);
      } catch (error) {
        return error;
      }
    },
    async consultarSolicitudXTicket({ commit }, data) {
      try {
        let res = await axios.get(`/v1/solicitudes-rechazadas/${data.ticket}/ticket`);
        const resultado = res?.data?.result || [];
        commit("setSolicitudesRechazadas", resultado);
        commit("setTotalPaginas", 1);
        return { success: true, data: resultado };
      } catch (error) {
        console.error("Error consultando solicitud por ticket:", error.message || error);
        commit("setSolicitudesRechazadas", []);
        commit("setTotalPaginas", 0);
        return { success: false, error: error };
      }
    },
    async consultarSolicitudXCliente({ commit }, data) {
      try {
        let res = await axios.get(`/v1/solicitudes-rechazadas/${data.codigoCliente}/cliente`);
        const resultado = res?.data?.result || [];
        commit("setSolicitudesRechazadas", resultado);
        commit("setTotalPaginas", 1);
        return { success: true, data: resultado };
      } catch (error) {
        console.error("Error consultando solicitud por cliente:", error.message || error);
        commit("setSolicitudesRechazadas", []);
        commit("setTotalPaginas", 0);
        return { success: false, error: error };
      }
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
